export default "__VITE_ASSET__DGOWQCru__"